import i18n from "../../../i18n";

const COLUMNS = {
  TIME: {
    id: 'TIME',
    label: i18n.t('Time'),
    path: 'posdate',
    format: 'LLLL dd, y HH:mm',
    type: 'date'
  },
  LOCATION: {
    id: 'LOCATION',
    label: i18n.t('Location'),
    path: 'location'
  },
  DATE_FROM: {
    id: 'DATE_FROM',
    label: i18n.t('From'),
    path: 'from_date',
    format: 'LLLL dd, y HH:mm',
    type: 'date'
  },
  DATE_TO: {
    id: 'DATE_TO',
    label: i18n.t('To'),
    path: 'to_date',
    format: 'LLLL dd, y HH:mm',
    type: 'date'
  },
  DURATION: {
    id: 'DURATION',
    label: i18n.t('Duration'),
    path: 'duration',
    type: 'duration'
  }
}

const COLUMNS_BY_VIEW: { [key: string]: string } = {
  collisions: [COLUMNS.TIME, COLUMNS.LOCATION],
  stops: [COLUMNS.DATE_FROM, COLUMNS.DATE_TO, COLUMNS.LOCATION, COLUMNS.DURATION]
}

export const getHistoryViewInfo = (view: string) => {
  if (COLUMNS_BY_VIEW[view]) {
    const viewColumns = COLUMNS_BY_VIEW[view]
    return viewColumns
  }

  return null
}
